module.exports = __webpack_public_path__ + "static/media/thermal-printer.3b223a97.svg";